import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { ADGMButton, ADGMImage, ADGMAlert } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';

import styles from './styles';

const AddRepresentativeButton = ({ classes, alertText, disableAddBtn, mandatory, addRepresentativeHandler }) => {
  return (
    <div className={classes.container}>
      {alertText && (
        <ADGMAlert type='warning' className={classes.alert}>
          <Typography className={classes.alertText}>{keyEmptyCheck(alertText)}</Typography>
        </ADGMAlert>
      )}
      <ADGMButton
        variant='secondary'
        className={classes.btn}
        onClick={addRepresentativeHandler}
        disabled={disableAddBtn}
      >
        <ADGMImage className={classes.btnIcon} name='add-icon2.svg' alt='add-buyer' />
        <span>
          {keyEmptyCheck('add_representative')}
          {mandatory && <span className={classes.mandatorySign}>*</span>}
        </span>
      </ADGMButton>
    </div>
  );
};

AddRepresentativeButton.propTypes = {
  classes: PropTypes.object.isRequired,
  alertText: PropTypes.string.isRequired,
  disableAddBtn: PropTypes.bool.isRequired,
  mandatory: PropTypes.bool.isRequired,
  addRepresentativeHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(AddRepresentativeButton));
